import { Media } from '../model/media.model';
import httpClient from '../util/http-client';

export const UploadService = {
  upload: async (file: File): Promise<(Media | any)[]> => {
    let data;
    let err;
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await httpClient.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      data = response.data ?? [];
    } catch (error: any) {
      data = error.response?.data || { success: false, message: error.message };
      err = error;
    }
    return [data, err];
  },
};
